// workspace-toolbar.js（ESM 版）— /list 桌面端侧边工具栏
// 绑定工具栏按钮点击（收藏/云盘/回收站/音乐/待办/灵感/日记）+ 收起/展开。
// 参考实现：story-writer/js/ui/sidebar.js（精简版，仅桌面端）。
// 幂等标志挂在工具栏容器 DOM 元素上（元素级）：跨 chunk 模板重注入后新 DOM 可重新绑定；
// 同 chunk 切换（DOM 不变）时 `toolbar._toolbarBound` 已置位，不会重复绑定。

import { animateListTransition } from './file-loader.js';
import { updateSearchPlaceholder } from './file-search.js';

var _switchFeature = null;
var _switchFileBrowser = null;

// 切换视图前关闭桌面端聊天面板（若打开），沿用原快捷按钮绑定行为
function _closeChatIfOpen() {
  var panel = document.querySelector('.xiaque-desktop-panel--open');
  if (!panel) return;
  import('@modules/desktop-chat-panel.js').then(function(mod) {
    if (mod.closeDesktopChatPanel) mod.closeDesktopChatPanel();
  }).catch(function() {});
}

// 文件视图切换统一入口：收藏 / 飞书 / 云盘 / 回收站 → 经 fileBrowser Feature（switchFileBrowserDesktop）
// view: 'star'|'file'|'trash'；source: 'feishu'|'cloud'（star/trash 时可为 null）
function _openFileBrowser(view, source) {
  _closeChatIfOpen();
  history.replaceState(null, '', '/list');
  var listEl = document.getElementById('fileListContainer');
  animateListTransition(listEl, function() {
    if (_switchFileBrowser) return _switchFileBrowser(view, source);
    return Promise.resolve();
  });
}

// 功能视图（音乐/待办/灵感/日记）：切换路由 feature
function _openFeatureNav(action, path, placeholder) {
  _closeChatIfOpen();
  history.replaceState(null, '', path);
  updateSearchPlaceholder(placeholder);
  var listEl = document.getElementById('fileListContainer');
  animateListTransition(listEl, function() {
    if (_switchFeature) _switchFeature(action);
  });
}

// 收起/展开侧边工具栏
function _toggleSidebar() {
  var expanded = document.body.classList.toggle('sidebar-expanded');
  try { localStorage.setItem('sidebar-expanded', expanded ? '1' : '0'); } catch (e) {}
}

// 初始化侧边工具栏（接收 switchFeatureDesktop / switchFileBrowserDesktop 引用，避免循环导入）
export function initSidebarToolbar(switchFeatureFn, switchFileBrowserFn) {
  var toolbar = document.querySelector('.sidebar');
  if (!toolbar || toolbar._toolbarBound) return;
  toolbar._toolbarBound = true;
  _switchFeature = switchFeatureFn;
  _switchFileBrowser = switchFileBrowserFn;
  // 展开状态已由 sidebar-state.js 在首绘时应用，这里无需重复还原

  // 按钮点击（事件委托，兼容模板重注入后的按钮）
  toolbar.addEventListener('click', function(e) {
    var btn = e.target.closest('.sidebar__btn[data-action]');
    if (!btn) return;
    e.preventDefault();
    var action = btn.getAttribute('data-action');
    switch (action) {
      case 'star': _openFileBrowser('star', null); break;
      case 'cloud': _openFileBrowser('file', 'feishu'); break; // 飞书（data-action="cloud" 文案「飞书」）
      case 'docs': _openFileBrowser('file', 'cloud'); break;  // 云盘（本地服务器，走 /api/local-docs）
      case 'trash': _openFileBrowser('trash', null); break;
      case 'home': _openFeatureNav('home', '/home', 'home'); break; // 首页工作台
      case 'music': _openFeatureNav('music', '/music', 'music'); break;
      case 'todo': _openFeatureNav('todo', '/todo', 'todo'); break;
      case 'bill': _openFeatureNav('bill', '/bill', 'bill'); break;  // 记账（v1.0.046）
      case 'project': _openFeatureNav('project', '/project', 'project'); break; // 项目
      case 'inspiration': _openFeatureNav('inspiration', '/spark', 'notes'); break;
      case 'diary': _openFeatureNav('diary', '/daily', 'diary'); break;
    }
  });

  // 收起把手
  var handleBtn = toolbar.querySelector('.sidebar__handle');
  if (handleBtn) {
    handleBtn.addEventListener('click', function(e) {
      e.preventDefault();
      _toggleSidebar();
    });
  }
}